import type { StateCreator } from 'zustand'

import type { WorkspaceStore } from '../types'

import type { WorkspaceDataSlice } from './workspace-data.slice.type'

export const createWorkspaceDataSlice: StateCreator<
  WorkspaceStore,
  [['zustand/immer', never]],
  [],
  WorkspaceDataSlice
> = () => ({
  workspace: null,
  members: [],
  notifications: [],
  loading: false,
  error: null,
})
